import React, {useEffect, useRef} from "react";
import MobileBottomNotifications from "../bottomNotifications/MobileBottomNotifications";
import CartBlockPDPMobile from "../../products/ProductPage/CartBlockPDP.mobile";
import CartPageCTAMobile from "../../products/ProductPage/CartPage.CTA.mobile";
import {useSelector} from "../../../shared-services/redux-tiny";

const MobileBottomDrawer = () => {
  const {bottomDrawer} = useSelector(state => state.topLayer);
  const ref = useRef();

  const getFooterElement = () => {
    return document.querySelector("footer");
  };

  useEffect(() => {
    if (bottomDrawer?.name) {
      requestAnimationFrame(() => {
        const height = ref.current?.clientHeight;
        if (height > 0) getFooterElement().style.marginBottom = `${height}px`;
      });
    }

    return () => {
      getFooterElement().style.marginBottom = null;
    };
  }, [bottomDrawer]);

  return <div ref={ref} className={`
    position-fixed
    bottom-0
    full-width
    z-index-top-layer
  `}>
    <div className="position-relative full-width">
      <MobileBottomNotifications/>
      <CartBlockPDPMobile style={{minHeight: "85px"}}/>
      <CartPageCTAMobile/>
    </div>
  </div>;
};

export default MobileBottomDrawer;
